import request from "@/utils/request";

export const getLogs = (params) =>
  request.get("/logs", {
    params,
    paramsSerializer: (params) => {
      const search = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value === null || value === undefined || value === "") return;
        if (Array.isArray(value)) {
          if (value.length === 0) return;
          value.forEach((v) => search.append(key, v));
        } else {
          search.append(key, value);
        }
      });
      return search.toString();
    },
  });
